
export default  [
   
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'date-range',
        field: 'created_at',
        label: 'Data de Cadastro',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_empresa',
        label: 'Empresa',
        clearable: true,
        option: {
            label: 'nome',
            value: 'id'
        },
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_funcionario',
        label: 'Funcionário',
        clearable: true,
        option: {
            label: 'nome',
            value: 'id'
        },
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'id_tipo_aso',
        label: 'Tipo de ASO',
        clearable: true,
        multiple: true,
        tipo: 46,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'id_tipo_status',
        label: 'Status',
        clearable: true,
        multiple: true,
        tipo: 53,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
        type: 'boolean',
        field: 'id_arquivo_aso',
        label: 'Mostrar Apenas Consultas com ASO Digitalizado ',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8',
        type: 'boolean',
        field: 'inativo',
        label: 'Mostrar Apenas Consultas Excluídas ',
        rules: ['']
    }
];




// WEBPACK FOOTER //
// ./src/components/apps/web/consulta/liberacao/_form/liberacao-filtro.js